import {
  useEffect, useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import { useTranslation } from 'react-i18next';
import {
  faBatteryFull,
  faBatteryThreeQuarters,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryEmpty,
} from '@fortawesome/free-solid-svg-icons';
import telemetryActions from '@state/telemetry/actions';

function useSystemStatus() {

  const dispatch = useDispatch();
  const [infoSystem, setInfoSystem] = useState({});
  const systemStatusGraph = useSelector(({ telemetry }) => telemetry.infoSystem);
  const loadingInfoSystem = useSelector(({ telemetry }) => telemetry.loadingInfoSystem);

  const [loading, setLoading] = useState(true);

  let statusSoc;
  let arrowDir;
  let arrowSolar;
  let arrowGrid;
  let arrowLoad;

  useEffect(() => {

    setInfoSystem(systemStatusGraph);
    dispatch(telemetryActions.setLoadingInfoSystem(false));

  },
  [systemStatusGraph]);

  const {
    solarPower,
    socBattery,
    statusBattery,
    loadConsumption,
    systemStatus,
    mode,
    batteryValue,
    powerGrid,
    gridStatus,
  } = infoSystem;

  if (socBattery > 75) {

    statusSoc = faBatteryFull;

  } else if ((socBattery > 60) && (socBattery <= 75)) {

    statusSoc = faBatteryThreeQuarters;

  } else if ((socBattery > 45) && (socBattery <= 60)) {

    statusSoc = faBatteryHalf;

  } else if ((socBattery > 25) && (socBattery <= 45)) {

    statusSoc = faBatteryQuarter;

  } else if (socBattery <= 25) {

    statusSoc = faBatteryEmpty;

  }

  if (statusBattery === 'Cargando') {

    arrowDir = 'directionLeft';

  } else if (statusBattery === 'Descargando') {

    arrowDir = 'directionRight';

  } else {

    arrowDir = 'directionLeftDeactivate';

  }

  if (solarPower > 0) {

    arrowSolar = 'directionBottom';

  } else {

    arrowSolar = 'directionBottomDeactivate';

  }

  if (gridStatus === 'Importando') {

    arrowGrid = 'directionTop';

  } else if (gridStatus === 'Exportando') {

    arrowGrid = 'directionBottom';

  } else {

    arrowGrid = 'directionTopDeactivate';

  }

  if (loadConsumption > 0) {

    arrowLoad = 'directionRight';

  } else {

    arrowLoad = 'directionRightDeactivate';

  }

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {

    setIsModalVisible(true);

  };

  const handleOk = () => {

    setIsModalVisible(false);

  };

  const handleCancel = () => {

    setIsModalVisible(false);

  };

  useEffect(() => {

    setLoading(loadingInfoSystem);

  }, [loadingInfoSystem]);

  return {
    isModalVisible,
    setIsModalVisible,
    showModal,
    handleOk,
    handleCancel,
    statusSoc,
    arrowDir,
    arrowSolar,
    arrowGrid,
    arrowLoad,
    solarPower,
    statusBattery,
    batteryValue,
    socBattery,
    loadConsumption,
    powerGrid,
    gridStatus,
    systemStatus,
    mode,
    loading,
  };

}

export default useSystemStatus;
